import { TextField } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

interface ReadOnlyTextFieldProps {
  readonly label: string;
  readonly value: string;
}

function ReadOnlyTextField({ label, value }: ReadOnlyTextFieldProps) {
  const { colors } = useCelleraTheme();

  return (
    <TextField
      label={label}
      value={value}
      fullWidth
      slotProps={{
        input: {
          readOnly: true,
        },
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: colors.background.paper,
          "& fieldset": {
            borderColor: colors.border.light,
          },
          "&:hover fieldset": {
            borderColor: colors.border.dark,
          },
        },
        "& .MuiInputLabel-root": {
          color: colors.text.bold,
          fontWeight: 500,
        },
      }}
    />
  );
}

export default ReadOnlyTextField;
